// Keep in sync with app/lib/enums/sort_direction.py
const SortDirection = {
  ASC: 'asc',
  DESC: 'desc',
};

export default SortDirection;
